import React from 'react'
import PageForm from '../form'

const BookingPolicy = () => {
  return <PageForm title="Booking Policy" Key="booking-policy" />
}

export default BookingPolicy
